import type { SVGProps } from "react";
import { cn } from "@/lib/utils";

const GCS = (props: SVGProps<SVGSVGElement>) => {
  const { className, ...rest } = props;
  return (
    <svg
      className={cn(className)}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12 2L2 7L12 12L22 7L12 2Z"
        fill="#4285F4"
        stroke="#4285F4"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        d="M2 17L12 22L22 17"
        stroke="#34A853"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M2 12L12 17L22 12"
        stroke="#FBBC04"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};

export default GCS;
